module.exports = __webpack_public_path__ + "img/8.2a1b0ca1.jpg";